












import { defineComponent } from '@vue/composition-api';

export default defineComponent({
    props: {
        address: {
            type: String,
            required: true,
        },
        displayedCharacters: {
            type: Number,
            default: 8,
        },
    },
});
